import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { ClockIcon } from '@navikt/aksel-icons';
import { OrgOverviewTopBar } from '../../../components/OrgOverviewTopBar';
import { ContainerCard } from '../../../components/ContainerCard/ContainerCard';
import { SchedulingSettingsForm } from '../../../components/SchedulingSettingsForm/SchedulingSettingsForm';
import { useGetOrganizationSchedulingSettings } from '../../../hooks/queries/useGetOrganizationSchedulingSettings';
import { useUpdateOrganizationSchedulingSettingsMutation } from '../../../hooks/mutations/useUpdateOrganizationSchedulingSettingsMutation';
import { Spinner } from '../../../components/Spinner/Spinner';
import { Alert } from '../../../components/Alert/Alert';
import { SYSTEM_DEFAULTS } from '../../../api/types/scheduling-settings.types';
import classes from './OrganizationSchedulingPage.module.css';

export const OrganizationSchedulingPage = () => {
  const { t } = useTranslation();
  const {
    data: settings,
    isLoading,
    error,
  } = useGetOrganizationSchedulingSettings();

  const saveMutation = useUpdateOrganizationSchedulingSettingsMutation();

  useEffect(() => {
    if (saveMutation.isSuccess) {
      toast.success(t('scheduling.page.successSaved'));
    }
  }, [saveMutation.isSuccess, t]);

  if (isLoading) {
    return (
      <>
        <OrgOverviewTopBar />
        <div className={classes.container}>
          <div className={classes.loadingContainer}>
            <Spinner label={t('scheduling.page.loading')} />
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <OrgOverviewTopBar />
        <div className={classes.container}>
          <ContainerCard>
            <ContainerCard.Body>
              <Alert variant="danger" size="md" title={t('scheduling.page.errorTitle')}>
                {t('scheduling.page.errorMessage')}
              </Alert>
            </ContainerCard.Body>
          </ContainerCard>
        </div>
      </>
    );
  }

  // Convert settings to effective settings format (use SYSTEM_DEFAULTS as fallback)
  const effectiveSettings = settings || SYSTEM_DEFAULTS;

  return (
    <>
      <OrgOverviewTopBar />
      <div className={classes.container}>
        <ContainerCard>
          <ContainerCard.Title icon={<ClockIcon aria-hidden />}>
            {t('scheduling.page.title')}
          </ContainerCard.Title>
          <ContainerCard.SubHeader>
            {t('scheduling.page.description')}
          </ContainerCard.SubHeader>
          <ContainerCard.Body>
            <SchedulingSettingsForm
              effectiveSettings={effectiveSettings}
              saveMutation={saveMutation}
              inputType="select"
            />
          </ContainerCard.Body>
        </ContainerCard>
      </div>
    </>
  );
};
